module.exports = __webpack_public_path__ + "img/logo-l-nega.f0c1b054.svg";